import IconButton from 'components/IconButton';
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { CartContext } from 'constants/contexts';

import { Badge } from '@mui/material';

function CartButton(props) {
  const { getQty, openCart } = useContext(CartContext);
  const qty = useMemo(getQty, [getQty]);

  return (
    <Badge
      badgeContent={qty}
      color="primary"
      sx={{
        '& .MuiBadge-badge': {
          transform: 'scale(0.8) translate(50%, -50%)',
        },
      }}
    >
      <IconButton name="cart-outlined" onClick={openCart} {...props} />
    </Badge>
  );
}
export default CartButton;
